export default {
  type_logement: {
    label: 'Quel est le type de logement ?',
    options: {
      apartment: 'Appartement',
      house: 'Maison',
      duplex: 'Duplex',
      triplex: 'Triplex',
      garde_meuble: 'Garde-meuble',
      other: 'Autre',
    },
  },
  cave: {
    label: 'Y a-t-il une cave ?',
    options: {
      yesBut: 'Oui, mais rien à déménager',
    },
  },
  floor: {
    label: {
      loading: 'A quel(s) étage(s) le chargement est-il prévu ?',
      delivery: 'A quel(s) étage(s) la livraison est-elle prévue ?',
    },
    options: {
      groundFloor: 'RDC',
      superiorTen: '10+',
    },
  },
};
